import { DialogTitle, Divider, GridProps, useTheme } from '@mui/material';
import { ContextForm, IFormAfterSubmit, InputOnlyField, Select, Text } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { Project } from '../../api/dtos';
import AgentLocationsContext from '../../contexts/AgentLocationsContext';
import { IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from '../inputs/CommonFormElements';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6
} 

const AgentLocationForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshAgentLocations } = useContext(AgentLocationsContext);
    

    const onAfterSubmit: IFormAfterSubmit<Project> = useCallback(async (_newValue, _formState, _formActions) => {
        await refreshAgentLocations();
        props.onClose();
    }, [refreshAgentLocations, props.onClose])

    return (
        <ContextForm
            onAfterSubmit={onAfterSubmit}
            validateOn={ValidateOn.onChange}
            validateOnReset
        >
            <StyledDialog {...props}>
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Agent Location
                </DialogTitle>
                <StyledDialogContent>
                    <StyledFormColumn
                        size={COLUMN_SIZING}
                    >
                        <InputOnlyField 
                            label="Agent"
                            component={Select}
                            propertyPath={'agentId'}
                        />
                        <InputOnlyField 
                            label="Location"
                            component={Text}
                            propertyPath={'location'}
                        />
                    </StyledFormColumn>
                </StyledDialogContent>
                <Divider />
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </StyledDialog>
        </ContextForm>
    );
}

export default AgentLocationForm;